<button
  (click)="openMenu()"
  class="mobile-hamburger-menu p-0"
  type="button"
  [attr.aria-label]="'app_global_menu' | translate"
>
  <i class="icon-hamburger-menu-1" data-cy="mobile-hamburger-menu.icon"> </i>
</button>
